<template>
  <div>
    <h3 class="agenda-day">
      {{ getFormatedDate }}
    </h3>

    <div
      class="each-event"
      v-for="event in agenda.dayAgendas"
      :key="event.agn_id"
    >
      <!-- 
    1 // breakout-session
    2 // session
    3 // speed-networking
    4 // 1 on 1 meetings
    5 // expo
    6 // defualt
     -->
      <a-card
        :id="
          isEventPassed(event.agn_id)
            ? 'passed' + event.agn_id
            : isEventActive(event.agn_id)
            ? 'live' + event.agn_id
            : isEventInMyAgenda(event.agn_id)
            ? 'myEvent' + event.agn_id
            : 'eventAgenda' + event.agn_id
        "
        :bordered="false"
        :class="[
          'id' + event.agn_id,
          'event-card',
          event.agt_id === 1
            ? 'turquise-card'
            : event.agt_id === 2
            ? 'purple-card'
            : event.agt_id === 3
            ? 'yellow-card'
            : event.agt_id === 4
            ? 'green-card'
            : event.agt_id === 5
            ? 'blue-card'
            : 'purple-card',
          isEventPassed(event.agn_id) ? 'passed' : '',
          isEventActive(event.agn_id) ? 'live' : '',
          isEventInMyAgenda(event.agn_id) ? 'myEvent' : '',
        ]"
        v-on:click="selectEvent(event, $event)"
      >
        <a-card-grid class="card-time" :hoverable="false">
          <div class="white-box">
            <p class="time-from">
              {{ getFromatedFrom(event)[0]
              }}<sub>{{ getFromatedFrom(event)[1] }}</sub>
            </p>
            <p class="time-to">
              {{$t('agendaNew.until')}}
              {{ getFromatedTo(event)[0]
              }}<sub>{{ getFromatedTo(event)[1] }}</sub>
            </p>
            <span class="live-event" v-if="isEventActive(event.agn_id)"
              >{{$t('agendaNew.live')}}</span
            >
          </div>
        </a-card-grid>
        <a-card-grid :hoverable="false" class="card-description"
        :style="{ background: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardBackgroundColor : 'white', color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black' }"
        >
          <a
            href="#"
            class="card-agenda"
            v-if="isEventInMyAgenda(event.agn_id)"
            v-on:click="$emit('removefrommyagenda', event.agn_id)"
            ><p>{{$t('agendaNew.addedToMyAgenda')}}</p>
            <a-icon
              class="agenda-star active"
              type="star"
              theme="filled"
              style="color:#f7bb58;"
            />
          </a>
          <a
            href="#"
            class="card-agenda"
            v-if="!isEventInMyAgenda(event.agn_id)"
            v-on:click="$emit('addtomyagenda', event.agn_id)"
            ><p>{{$t('agendaNew.addToMyAgenda')}}</p>
            <a-icon
              class="agenda-star active"
              type="star"
              theme="outlined"
              :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black' }"
            />
          </a>
          <div class="card-content-container">
            <p class="card-title" :title="event.agn_name">
              {{ event.agn_name }}
            </p>
            <!-- Card buttons for breakout sessions -->
            <div class="card-buttons" v-if="event.agt_id == 1">
              <div v-if="!previewClosed && !isMobile">
              <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags ? event.tags.slice(0, 1) : []"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              ><a class="card-button tag" v-if="getTagsLength(event.tags)" v-on:click="$emit('closepreview')" :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }">{{ getTagsLength(event.tags) }}</a>
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              </div>
              <div v-if="previewClosed && isMobile">
              <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags ? event.tags.slice(0, 1) : []"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              ><a class="card-button tag" v-if="getTagsLength(event.tags)" v-on:click="$emit('closepreview')" :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }">{{ getTagsLength(event.tags) }}</a>
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              <a
                :href="eventLink(event)"
                class="card-button join"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.joinSession')}}</a
              >
              <a
                :href="eventLink(event)"
                class="card-button rewatch"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.rewatch')}}</a
              >
              <a class="card-button coming-soon" target="_blank"
              v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.commingSoon')}}</a
              >
              </div>
              <div v-if="previewClosed && !isMobile">
                <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              >
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              <a
              :href="eventLink(event)"
                class="card-button join"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.joinSession')}}</a
              >
              <a
              :href="eventLink(event)"
                class="card-button rewatch"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.rewatch')}}</a
              >
              <a class="card-button coming-soon" target="_blank"
              v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.commingSoon')}}</a
              >
              </div>
            </div>
            <!-- Card buttons for all other sessions -->
            <div class="card-buttons" v-if="event.agt_id !=1">
              <div v-if="!previewClosed && !isMobile">
              <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags ? event.tags.slice(0, 1) : []"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              ><a class="card-button tag" v-if="getTagsLength(event.tags)" v-on:click="$emit('closepreview')" :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }">{{ getTagsLength(event.tags) }}</a>
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              </div>
              <div v-if="previewClosed && isMobile">
              <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags ? event.tags.slice(0, 1) : []"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              ><a class="card-button tag" v-if="getTagsLength(event.tags)" v-on:click="$emit('closepreview')" :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }">{{ getTagsLength(event.tags) }}</a>
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              <a
                :href="eventLink(event)"
                class="card-button join"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.joinSession')}}</a
              >
              <a
                :href="eventLink(event)"
                class="card-button rewatch"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.rewatch')}}</a
              >
              <a class="card-button coming-soon" target="_blank"
              v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.commingSoon')}}</a
              >
              </div>
              <div v-if="previewClosed && !isMobile">
              <a
                href="#"
                class="card-button tag"
                :style="{ color: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black', borderColor: event.agn_additional ? JSON.parse(event.agn_additional).sessionCardTextColor : 'black'  }"
                v-for="tag in event.tags"
                :key="tag"
                v-on:click="$emit('filterbytag', tag)"
                >{{ tag }}</a
              >
              <a href="#" class="card-button lang"
                ><a-icon type="flag" style="font-size:12px" /> English</a
              >
              <a
                :href="eventLink(event)"
                class="card-button join"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.joinSession')}}</a
              >
              <a
                :href="eventLink(event)"
                class="card-button rewatch"
                target="_blank"
                v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.rewatch')}}</a
              >
              <a class="card-button coming-soon" target="_blank"
              v-if="sid  || fairConfig.FC_PUBLIC == 1"
                >{{$t('agendaNew.commingSoon')}}</a
              >
              </div>
            </div>
          </div>
        </a-card-grid>
      </a-card>
    </div>
    <!-- <a-card
        :bordered="false"
        class="gray-card dimmed"
        v-on:click="$emit('selectevent', event)"
      >
        <a-card-grid style="width:50%;" :hoverable="false">
          <div class="space-align-block">
            <font-awesome-icon
              :style="{ color: 'white' }"
              :icon="['fal', 'podium']"
            />
          </div>
          <div class="card-content-container">
            <p class="card-content">
              {{ event.agn_name }}
            </p>
            <a href="#" class="card-button">Tag filter 1</a>
            <a href="#" class="card-lang-link"
              ><img
                src="../../assets/icons/united-kingdom.svg"
                class="card-lang"
            /></a>
          </div>
        </a-card-grid>
        <a-card-grid style="width:50%;text-align:right" :hoverable="false">
          <a href="#" class="card-agenda"
            >Add to my agenda
            <font-awesome-icon :icon="['fad', 'star']" class="agenda-star"
          /></a>
          <p class="card-time">
            {{ event.agn_from.split(" ")[1].slice(0, 5) }}
          </p>
        </a-card-grid>
      </a-card> -->

    <!-- <a-card :bordered="false" class="green-card active">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'sunrise']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">Welcome speech</p>
                <a href="#" class="card-button">Tag filter 2</a>
                <a href="#" class="card-lang-link"
                  ><img
                    src="../../assets/icons/united-kingdom.svg"
                    class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Added to my agenda
                <font-awesome-icon
                  :icon="['fad', 'star']"
                  class="agenda-star active"
              /></a>
              <p class="card-time">11:00</p>
            </a-card-grid>
          </a-card>

          <a-card :bordered="false" class="green-card">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'door-open']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">1 on 1 discussion</p>
                <a href="#" class="card-button">Tag filter 2</a>
                <a href="#" class="card-lang-link"
                  ><img
                    src="../../assets/icons/united-kingdom.svg"
                    class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Add to my agenda
                <font-awesome-icon :icon="['fad', 'star']" class="agenda-star"
              /></a>
              <p class="card-time">11:00</p>
            </a-card-grid>
          </a-card>

          <a-card :bordered="false" class="blue-card">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'presentation']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">Panel discussion</p>
                <a href="#" class="card-button">Tag filter 1</a>
                <a href="#" class="card-lang-link"
                  ><img src="../../assets/icons/serbia.svg" class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Added to my agenda
                <font-awesome-icon
                  :icon="['fad', 'star']"
                  class="agenda-star active"
              /></a>
              <p class="card-time">12:15</p>
            </a-card-grid>
          </a-card>

          <h3 class="agenda-day">Saturday, July 10, 2021</h3>

          <a-card :bordered="false" class="yellow-card">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'keynote']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">
                  Keynote: "How social robots can impact society?"
                </p>
                <a href="#" class="card-button">Tag filter 3</a>
                <a href="#" class="card-lang-link"
                  ><img
                    src="../../assets/icons/united-kingdom.svg"
                    class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Add to my agenda
                <font-awesome-icon :icon="['fad', 'star']" class="agenda-star"
              /></a>
              <p class="card-time">12:00</p>
            </a-card-grid>
          </a-card>

          <a-card :bordered="false" class="gray-card">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'presentation']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">Panel discussion</p>
                <a href="#" class="card-button">Tag filter 1</a>
                <a href="#" class="card-lang-link"
                  ><img
                    src="../../assets/icons/united-kingdom.svg"
                    class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Add to my agenda
                <font-awesome-icon :icon="['fad', 'star']" class="agenda-star"
              /></a>
              <p class="card-time">13:00</p>
            </a-card-grid>
          </a-card>

          <a-card :bordered="false" class="gray-card">
            <a-card-grid style="width:50%;" :hoverable="false">
              <div class="space-align-block">
                <font-awesome-icon
                  :style="{ color: 'white' }"
                  :icon="['fal', 'comments-alt']"
                />
              </div>
              <div class="card-content-container">
                <p class="card-content">Side chat</p>
                <a href="#" class="card-button">Tag filter 1</a>
                <a href="#" class="card-lang-link"
                  ><img
                    src="../../assets/icons/united-kingdom.svg"
                    class="card-lang"
                /></a>
              </div>
            </a-card-grid>
            <a-card-grid style="width:50%;text-align:right" :hoverable="false">
              <a href="#" class="card-agenda"
                >Add to my agenda
                <font-awesome-icon :icon="['fad', 'star']" class="agenda-star"
              /></a>
              <p class="card-time">13:45</p>
            </a-card-grid>
          </a-card> -->

    <!-- <div class="agenda-table-wrap">
    <div class="table-header">
      <div class="agenda-date">
        {{ getFormatedDate }}
      </div>
      <div class="button" v-if="index === 0">
        <a :href="'/api/agenda/pdf?sid=' + sid">{{ $t("button.download") }}</a>
      </div>
    </div>
    <div
      class="each-event"
      v-for="(event, index) in agenda.dayAgendas"
      :key="event.agn_id"
    >
      <div
        class="visible-info"
        :class="
          event.agn_desc !== null && event.agn_desc !== '' ? 'clickable' : ''
        "
      >
        <div class="event-time">
          {{
            event.agn_from.split(" ")[1].slice(0, 5) +
              " - " +
              event.agn_to.split(" ")[1].slice(0, 5)
          }}
        </div>
        <div class="event-info">
          <router-link :to="'/live/' + event.loc_id" class="info-wrap">
            <span>{{ event.agn_name }}</span>
            <span>{{ event.agn_lecturer }}</span>
          </router-link> -->

          <!-- <div class="ics-wrap">
            <a :href="'/api/calendar?agn_id=' + event.agn_id + (sid? '&sid=' + sid : '')">
              <img :src="$images.ics" alt="">
            </a>
          </div> -->
    <!--  <div
            class="more-info"
            @click="openMoreInfo(event, index)"
            v-if="event.agn_desc !== null && event.agn_desc !== ''"
          >
            <img
              :class="event.displayMoreInfo ? 'arrow-up' : 'arrow-down'"
              src="../../assets/icons/agendaArrow.png"
              alt="arrow.png"
            />
          </div>
        </div>
      </div>
      <div class="hidden-info" v-if="event.displayMoreInfo">
        <div class="hidden-info-content">
          <pre>{{ event.agn_desc }}</pre>
        </div>
      </div>
    </div>
  </div> -->
  </div>
</template>

<script>
import api from '@/api'
import moment from "moment";
import { mapState } from 'vuex';
export default {
  props: {
    index: Number,
    agenda: Object,
    myAgendas: Array,
    activeAgendas: Array,
    passedAgendas: Array,
    previewClosed: Boolean,
  },
  data() {
    return {
      eventFrom: [],
      eventTo: [],
      eventJoinLink: '',
      isMobile: false,
    };
  },
  computed: {
    getFormatedDate() {
      if (this.agenda.groupDate !== "") {
        
        if (process.env.VUE_APP_I18N_LOCALE == 'rs') {
          moment.locale("sr");
        }
        if (process.env.VUE_APP_I18N_LOCALE == 'ba') {
          moment.locale("bs");
        }
        return moment(this.agenda.groupDate, "YYYY-MM-DD").format(
          "dddd, MMMM Do YYYY"
        ); //"DD.MM.YYYY"
      } else {
        return "No agenda";
      }
    },
    sid() {
      return localStorage.getItem("sid");
    },
    ...mapState(["fairConfig"]),
  },
  created() {
    console.log("mounted")
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.isMobile = true;
    }
  },
  methods: {
    eventLink(event){
      let eventLink = "/live/" + event.loc_id;

      if (event.agn_additional) {
      this.eventAdditionalInfo = JSON.parse(event.agn_additional);

        if (this.eventAdditionalInfo.videoUrl) {
          if(this.eventAdditionalInfo.videoUrl.includes('youtube.com')){
            // video link - youtube
            let videoId = this.eventAdditionalInfo.videoUrl.split('?v=')[1];
            eventLink = eventLink + '?video_src=' + 'https://www.youtube.com/embed/' + videoId;
          }
          else if(this.eventAdditionalInfo.videoUrl.includes('vimeo.com')){
            // video link - vimeo
            let videoId = this.eventAdditionalInfo.videoUrl.split('vimeo.com/')[1];
            eventLink = eventLink + '?video_src=' + 'https://player.vimeo.com/video/' + videoId;
          }
        }

      }
      return eventLink;
    },
    getTagsLength(tags){
      if(tags && tags.length >1){
        return '+' + (tags.length - 1);
      }else{
        return null;
      }
    },
    getFromatedFrom(event) {

      let from, formatedFrom, formatedAmPm;

      if (process.env.VUE_APP_I18N_LOCALE !== 'en') {
        if (process.env.VUE_APP_I18N_LOCALE == 'rs') {
          moment.locale("sr");
        }
        if (process.env.VUE_APP_I18N_LOCALE == 'ba') {
          moment.locale("bs");
        }
        from = moment(event.agn_from, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
        formatedFrom = from.split(" ")[0];
        formatedAmPm = '';
      }
      else{
        from = moment(event.agn_from, "YYYY-MM-DD HH:mm:ss").format("h:mm A");
        formatedFrom = from.split(" ")[0];
        formatedAmPm = from.split(" ")[1];
      }

      return [formatedFrom, formatedAmPm];
    },
    getFromatedTo(event) {

      let to, formatedTo, formatedAmPm;

      if (process.env.VUE_APP_I18N_LOCALE !== 'en') {
        if (process.env.VUE_APP_I18N_LOCALE == 'rs') {
          moment.locale("sr");
        }
        if (process.env.VUE_APP_I18N_LOCALE == 'ba') {
          moment.locale("bs");
        }
        to = moment(event.agn_to, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
        formatedTo = to.split(" ")[0];
        formatedAmPm = '';
      }
      else{
        to = moment(event.agn_to, "YYYY-MM-DD HH:mm:ss").format("h:mm A");
        formatedTo = to.split(" ")[0];
        formatedAmPm = to.split(" ")[1];
      }

      return [formatedTo, formatedAmPm];
    },
    openMoreInfo(item, index) {
      if (item.agn_desc === null) {
        return;
      }
      this.agenda.dayAgendas[index].displayMoreInfo = !this.agenda.dayAgendas[
        index
      ].displayMoreInfo;
    },
    isEventInMyAgenda(eventId) {
      if (
        this.myAgendas.filter((agenda) => agenda.agn_id === eventId).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEventActive(eventId) {
      if (this.activeAgendas) {
        if (
          this.activeAgendas.filter((agenda) => agenda.agn_id === eventId)
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    isEventPassed(eventId) {
      if (this.passedAgendas) {
        if (
          this.passedAgendas.filter((agenda) => agenda.agn_id === eventId)
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    selectEvent(event, id) {
      var previouslySelected = document.getElementsByClassName(
        "event-card active"
      );

      previouslySelected.forEach((element) => {
        element.classList.remove("active");
      });

      id.currentTarget.classList.add("active");
      // removed by request - 23.12.2021
      // this.trackEvent(event.agn_name);
      this.$emit("selectevent", event);
    },
    async trackEvent(eventName){
      // send tracking info to server
      try {
        let obj = {
          code:'agenda_item_visit',
          data:eventName
        };
        await api.postTracking(obj);
      } catch (error) {
        console.log("error: ", error);
        this.handleError(error);
      }
    }
  },
};
</script>

<style scoped lang="scss">
@keyframes openRow {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 2000px;
  }
}
* {
  box-sizing: border-box;
}
/* .agenda-table-wrap {
  display: flex;
  flex-direction: column;
  width: 80%;
  margin-bottom: 4%;
}
.table-header {
  display: flex;
  background-color: #5caddd;
  justify-content: space-between;
  color: #ffffff;
  font-size: 20px;
  height: 45px;
}
.agenda-date {
  display: flex;
  align-items: center;
  padding: 1%;
}
.button {
  display: flex;
  text-align: center;
  height: 100%;
  padding: 0 10px;
  background-color: #7397ce;
  border: none;
  outline: none;
  font-weight: 600;
  font-size: 17px;
  cursor: pointer;
}
.ics-wrap {
  margin-right: 15px;
  img {
    width: 35px;
    height: 35px;
  }
}
.google-calendar-wrap {
  width: 35px;
  height: 35px;
  margin-right: 15px;
}
.table-header .button a {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  color: #fff;
}
.each-event {
  display: flex;
  flex-direction: column;
  color: #000;
}
.clickable {
  cursor: pointer;
}
.visible-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #e2f5ef;
  margin-bottom: 2px;
}
.hidden-info {
  background-color: #e2f5ef;
  margin-bottom: 2px;
  animation-name: openRow;
  animation-duration: 1s;
  display: flex;
  justify-content: flex-end;
}
.hidden-info-content {
  opacity: 0.6;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  flex-grow: 1;
  overflow: hidden;
  padding: 1% 3% 1% 15%;
}
.event-time {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1%;
  min-width: 15%;
  font-size: 22px;
  font-weight: 600;
}
.event-info {
  display: flex;
  flex-direction: row;
  width: 85%;
  justify-content: space-between;
  align-items: center;
  padding: 1% 0;
}
.info-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
}
.more-info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
}
.event-info span:nth-of-type(1) {
  display: inline-block;
  margin-bottom: 4px;
  font-weight: 600;
}
.event-info span:nth-of-type(2) {
  opacity: 0.6;
}
.arrow-down {
  transform: rotate(180deg);
}
pre {
  font-family: "Roboto";
  white-space: pre-wrap;
}
@media (max-width: 750px) {
  .hidden-info-content {
    padding-left: 50%;
  }
  .event-info {
    width: 50%;
  }
  .event-time {
    display: flex;
    align-items: center;
    min-width: 50%;
    font-size: 1em;
  }
}
@media (max-width: 1400px) {
  .hidden-info-content {
    padding-left: 25%;
  }
  .event-info {
    width: 75%;
  }
  .event-time {
    display: flex;
    align-items: center;
    min-width: 25%;
  }
}
@media (max-width: 400px) {
  .event-info {
    width: 75%;
  }
  .hidden-info-content {
    padding-left: 32%;
  }
  .event-time {
    display: flex;
    align-items: center;
    min-width: 25%;
  }
}
@media (max-width: 300px) {
  .event-info {
    width: 65%;
  }
  .hidden-info-content {
    padding-left: 35%;
  }
  .event-time {
    display: flex;
    align-items: center;
    min-width: 35%;
  }
}
 */
.page-title {
  color: #001529;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  text-align: left;
}

.download-btn {
  background: #fff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  color: #2c396a;
  font-size: 16px;
  line-height: 40px;
  font-family: "Roboto", sans-serif;
  float: right;
  height: 40px;
  margin-right: 10px;
}

.download-btn .fa-download {
  margin-left: 14px;
  line-height: 24px;
  font-size: 16px;
  vertical-align: 0;
}

.search-btn {
  background: #fff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  color: #2c396a;
  font-size: 16px;
  line-height: 24px;
  font-family: "Roboto", sans-serif;
  float: right;
  height: 40px;
  width: 200px;
}

.filter-headline {
  display: inline-block;
  margin-right: 10px;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #001529;
  font-family: "Roboto", sans-serif;
  margin-bottom: 8px;
}

.filter-btn .fa-check {
  vertical-align: -0.1em;
  margin-left: 5px;
}

input:focus-visible {
  outline: none !important;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card-head {
  border: 0 !important;
}

.ant-card-body {
  padding: 0 !important;
}

.ant-tabs-tab {
  margin-bottom: 10px !important;
}

.agendaTabs .ant-tabs-tab-active {
  color: #374785 !important;
}

.agenda-day {
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  text-transform:capitalize;
}

.gray-card.dimmed .space-align-block {
  background: #cbcbe4;
}

.space-align-container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  background: #f1f1f8;
  border-radius: 2px;
}

.space-align-block {
  text-align: center;
  display: inline-block;
  font-size: 32px;
  width: 92px;
  height: 92px;
  padding: 30px;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
}

.white-box {
  background: white;
  color: #001529;
  text-align: right;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 36px;
}

.white-box .time-from {
  margin: 0;
}

.white-box sub {
  bottom: 0;
}

.white-box sub,
.white-box .time-to {
  font-size: 16px;
  margin: 0;
}

.passed .white-box, .white-box .time-to {
  //color: #cbcbe4;
  color:#001529;
}

.live-event {
  display: block;
}

.live .live-event {
  padding: 1px 20px;
  background: #d23214;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  position: relative;
  top: -8px;
  color: #fff;
  display: inline-block;
}

.card-title {
  display: block;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  max-width: 50%;
}

.card-content-container {
  color: inherit;
  margin-top: -24px;
}

.passed .card-content-container,
.live .card-content-container {
  margin-top: 0;
}

.card-time {
  width: 145px;
}

.card-buttons {
  position: absolute;
  bottom: 16px;
}

.card-button {
  padding: 2px 4px;
  text-align: center;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  //background-color: rgba(255, 255, 255, 0.75);
  background:transparent;
  border: 1px solid white;
}

.card-button.lang {
  margin-left: 10px;
}

.card-button.tag {
  margin-right: 4px;
}

.card-button.join,
.card-button.rewatch,
.card-button.coming-soon {
  text-transform: uppercase;
  float: right;
  background: #fff;
  position: relative;
  display: none;
}

.live .card-button.join {
  display: inline-block;
  color:black !important;
}

.passed .card-button.rewatch {
  display: inline-block;
  color:black !important;
}

.live .card-button.coming-soon,
.passed .card-button.coming-soon {
  display: none;
}

.card-button.coming-soon {
  display: inline-block;
  color:black !important;
}

.card-lang-link {
  position: absolute;
  bottom: 16px;
  left: 220px;
}

.card-lang {
  height: 36px;
  width: 36px;
  border-radius: 2px;
}

.card-agenda {
  display: block;
  color: inherit;
  font-size: 12px;
  line-height: 24px;
  font-family: "Roboto", sans-serif;
  text-align: right;
  opacity: 1;
}

.card-agenda p {
  margin-bottom: 0;
  display: inline;
  margin-right: 6px;
}

.ant-card-grid {
  box-shadow: none;
  height: 124px;
  padding: 16px;
  padding-left: 0;
}

.passed .card-description,
.passed .card-button {
  //color: #cbcbe4 !important;
  color: white !important;
}

.passed .card-button:hover {
  cursor: not-allowed;
}

.passed .card-button.rewatch:hover {
  cursor: pointer;
}

/* Removed by request 28.12.2021
.passed .card-agenda,
.live .card-agenda {
  display: none;
} 
*/

.passed .card-agenda:hover,
.live .card-agenda:hover {
  cursor: default;
}

.gray-card .card-description {
  background: #ebebf5;
}

.card-description {
  padding: 16px;
  border-radius: 2px;
  color: white;
  width: calc(100% - 145px);
  float: right;
}

.event-card.passed .card-description {
  //background: #f0f0f8;
  background: #2295D6;
}

.green-card .card-description {
  background: #4bc076;
}

.purple-card .card-description {
  //background: #b4b4dc;
  background: #2295D6;
}

.blue-card .card-description {
  background: #56158b;
}

.yellow-card .card-description {
  background: #f0aa3c;
}

.turquise-card .card-description {
  background: #2295d6;
}

/* .event-card.passed.active {
  border-right: 5px solid #b2bac7 !important;
}

.green-card.active {
  border-right: 5px solid #44ad6a;
}

.purple-card.active {
  border-right: 5px solid #a2a2c6;
}

.turquise-card.active {
  border-right: 5px solid #1f86c1;
}

.yellow-card.active {
  border-right: 5px solid #d89936;
}

.blue-card.active {
  border-right: 5px solid #4d137d;
} */

.agenda-star {
  font-size: 16px;
  vertical-align: -0.25em;
}

.gray-card.dimmed .card-button {
  color: #2c396a;
}

.gray-card .card-button {
  color: #2c396a;
}

.purple-card .card-button {
  //color: #a2a2c6;
  color:white;
}

.purple-card .coming-soon{
  color:black;
}

.green-card .card-button {
  color: #4ba673;
}

.blue-card .card-button {
  color: #323f75;
}

.yellow-card .card-button {
  color: #d89936;
}

.turquise-card .card-button {
  color: white;
}

.gray {
  color: #7c7c7c;
  font-weight: 700;
  font-size: 18px;
  line-height: 40px;
  display: inline;
  font-family: "Roboto", sans-serif;
}

.align-right {
  float: right;
}

.session-heading {
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  font-family: "Roboto", sans-serif;
  margin-top: 10px;
  margin-bottom: 0;
}

.session-type {
  font-size: 16px;
  line-height: 28px;
  text-transform: uppercase;
  color: #2c396a;
  font-family: "Roboto", sans-serif;
  margin-bottom: 0;
}

.session-description-heading {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #b7b7cd;
  text-transform: uppercase;
  font-family: "Roboto", sans-serif;
}

.session-description {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #001529;
  font-family: "Roboto", sans-serif;
}

.green-btn {
  background: #5ecf90;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  padding: 8px 44px;
  height: 40px;
  display: block;
  font-family: "Roboto", sans-serif;
}

.sesssion-additional-info-heading {
  font-size: 14px;
  line-height: 22px;
  color: #001529;
  text-transform: uppercase;
  padding-top: 24px;
  font-family: "Roboto", sans-serif;
}

.sesssion-additional-info {
  display: flex;
  flex-direction: row;
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  color: #001529;
  font-family: "Roboto", sans-serif;
}

.pl-14 {
  padding-left: 14px;
}

.strong {
  font-weight: 700;
}

.gray-hr {
  color: #e5e5e5;
  border-top: 0;
}

.svg-inline--fa {
  vertical-align: 0.125em;
}

.fa-star {
  vertical-align: -0.125em;
}

.add-to-agenda-btn {
  margin-left: 8px;
  background: #fff;
  height: 40px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  color: #2c396a;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.add-to-calendar-btn {
  background: #f1f1f8;
  border-radius: 2px;
  padding: 4px 16px;
  width: 190px;
  color: #262626;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.add-to-calendar-btn .ant-select-arrow {
  color: #262626;
}

.gray-dropdown {
  background: #f1f1f8;
  border-radius: 2px;
  padding: 4px 16px;
  color: #7c7c7c;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.gray-dropdown .ant-select-arrow {
  color: #7c7c7c;
}

.white-dropdown {
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  margin-right: 16px;
  color: #262626;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
  height: 40px;
  padding-top: 3px;
}

.filter-row {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 20px;
}

.filter-btn {
  padding: 1px 8px;
  border-radius: 2px;
  border: 0;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
}

.green-filter {
  color: #4ba673;
  background: #cff1de;
}

.filter-btn-no {
  margin-left: 10px;
  background: #e5e5e5;
  border-radius: 2px;
  color: #939393;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
  padding: 0 8px;
  border: 0;
}

.filter-wrap {
  display: block;
  width: auto;
  margin-left: auto;
  margin-bottom: -40px;
  margin-top: 15px;
  z-index: 3;
}

h2 .agenda-star {
  font-size: 32px;
  margin-left: 10px;
}

.session-image {
  margin: 16px 0;
  border-radius: 2px;
  width: 100%;
}

.active-sessions-tab {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff0000;
  display: inline-block;
  margin-right: 5px;
}

.heading-wrap h1,
.heading-wrap h2,
.heading-wrap h3 {
  margin: 0.5% 0;
}
.heading-wrap h2 {
  font-weight: 100;
}
.heading-wrap {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.ics-wrap {
  display: flex;
  justify-content: flex-end;
  width: 80%;
  margin-bottom: 10px;
  img {
    width: 35px;
    height: 35px;
  }
  a {
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #7397ce;
    border: none;
    outline: none;
    font-weight: 600;
    font-size: 17px;
    cursor: pointer;
    color: white;
    border-radius: 15px;
  }
}
.agenda-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.message {
  text-align: center;
  margin-top: 270px;
}
.arrow-wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: sticky;
  bottom: 40px;
  opacity: 0.8;
}
</style>
